/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  Snackbar,
  Alert,
  Divider,
} from "@mui/material";
import { 
  StyledTitle,
  StyledSubTitle,
  StyledFormContainer,
  StyledEmailField,
  StyledResetLinkButton,
  StyledBackToLoginButton,
  ForgotPasswordContainer,
  FormFieldTitle,
  CarouselContainer,
  FormContainer,
  FormWrapper,
} from "./styles";
import api from "../../api";
import { LoadingSpinner } from "../../components/loading_spinner";
import { CarouselPage } from "../../components/carousel";
import banner from '../../assets/images/banner.jpg';

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('')
  const [error, setError] = React.useState([])
  const [status, setStatus] = React.useState(false)
  const [successOpen, setSuccessOpen] = React.useState(false)
  const [active, setActive] = React.useState(true)
  const carouselData = [
    {
      id: 1,
      image: banner,
    },
    {
      id: 2,
      image: banner,
    },
    {
      id: 3,
      image: banner,
    },
  ]

  const handleEmail = (value) => {
    setEmail(value)
    if(error?.email){
      setError('')
    }
    if(value) {
      setActive(false)
    }
    else {
      setActive(true)
    }
  }

  const handleClose = () => {
    setSuccessOpen(false)
    navigate('/admin/home')
  }

  const handleSendResetLink =  async () => {
    setStatus(true)
    await api.post('/v1/admin/forgot_password', { email: email })
    .then(() => {
      setStatus(false)
      setSuccessOpen(true)
    })
    .catch((error) => {
      setError(error?.response?.data?.errors)
      setStatus(false)
    })
  }

  return (
    <React.Fragment>
      <div>
        {/* Success Alert */}
        <Snackbar
          open={successOpen}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            variant="filled"
          >
            Check your email for reset password link
          </Alert>
        </Snackbar>

        <ForgotPasswordContainer>
          <CarouselContainer>
            <CarouselPage data={carouselData} />
          </CarouselContainer>

          <FormContainer>
            <FormWrapper>
              <StyledTitle>Forgot Password</StyledTitle>
              <StyledSubTitle>Enter the email associated with your account and we’ll send an email with instructions to reset your password.</StyledSubTitle>
              <Divider style={{borderStyle: 'solid', borderWidth: '2px', marginBottom: '20px', backgroundColor: '#252525'}}/>

              <StyledFormContainer>
                <FormFieldTitle>Email address</FormFieldTitle>
                <StyledEmailField
                  placeholder="Email address"
                  onChange={(e) => handleEmail(e.target.value)}
                  error={error?.email}
                  helperText={error?.email && error?.email[0]}
                />
                <div style={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
                  <StyledBackToLoginButton 
                    variant="outlined"
                    onClick={() => navigate('/')}
                  >
                    Back to log in
                  </StyledBackToLoginButton>
                  <StyledResetLinkButton 
                    onClick={handleSendResetLink}
                    disabled={status || active}
                  >
                    { status ? <LoadingSpinner isLoading={true} /> : 'Send' }
                  </StyledResetLinkButton>
                </div>
              </StyledFormContainer>
            </FormWrapper>
          </FormContainer>
        </ForgotPasswordContainer>
      </div>
    </React.Fragment>
  )
}
